import { useLang } from "@/context/LangContext";

const EDU = [["more", "#2a9d8f"], ["same", "#94a3b8"], ["less", "#e4572e"], ["na", "#d6d3e6"]];
const WEALTH = [["wealthier", "#f2b705"], ["poorer", "#0ea5e9"], ["same", "#94a3b8"]];
const LABEL = { more: "sum_more", less: "sum_less", same: "sum_same", na: "sum_na", wealthier: "sum_wealthier", poorer: "sum_poorer" };

function Bar({ title, rows, counts, testid }) {
  const { t, lang } = useLang();
  const shown = rows.filter(([k]) => counts[k]);
  const total = shown.reduce((a, [k]) => a + counts[k], 0);
  return (
    <div className="bg-white rounded-[22px] p-5" data-testid={testid}>
      <div className={`text-[13px] font-bold text-[#1a1640] ${lang === "ta" ? "font-tamil" : ""}`}>{title}</div>
      <div className="mt-3 flex h-3 rounded-full overflow-hidden">
        {shown.map(([k, c]) => <div key={k} style={{ width: `${(counts[k] / total) * 100}%`, background: c }} />)}
      </div>
      <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5">
        {shown.map(([k, c]) => (
          <div key={k} className={`flex items-center gap-2 text-[12.5px] text-[#1a1640] ${lang === "ta" ? "font-tamil" : ""}`}>
            <span className="w-2.5 h-2.5 rounded-sm" style={{ background: c }} />
            <span className="flex-1">{t(LABEL[k])}</span>
            <span className="font-bold tabular-nums" data-testid={`${testid}-${k}`}>{counts[k]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function TransitionSummary({ seats }) {
  const { t, lang } = useLang();
  const compared = seats.filter((s) => s.y2021 && s.y2026);
  const edu = {}; const wealth = {};
  for (const s of compared) {
    edu[s.compare.education] = (edu[s.compare.education] || 0) + 1;
    wealth[s.compare.wealth] = (wealth[s.compare.wealth] || 0) + 1;
  }
  return (
    <div>
      <div className="grid sm:grid-cols-2 gap-3">
        <Bar title={t("summary_edu")} rows={EDU} counts={edu} testid="summary-edu" />
        <Bar title={t("summary_wealth")} rows={WEALTH} counts={wealth} testid="summary-wealth" />
      </div>
      <p className={`mt-2 text-[11.5px] text-[#8c89ad] ${lang === "ta" ? "font-tamil" : ""}`}>
        {t("sum_compared_note").replace("{n}", compared.length)}
      </p>
    </div>
  );
}
